import script from "./material-shaped-button.vue?vue&type=script&setup=true&lang=ts"
export * from "./material-shaped-button.vue?vue&type=script&setup=true&lang=ts"

import "./material-shaped-button.vue?vue&type=style&index=0&id=5a4379aa&scoped=true&lang=scss"

import exportComponent from "/builds/snedson/snotra-backend/snotra-front-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a4379aa"]])

export default __exports__